import type { RequestAggregateGroupBy } from "@/api/endpoints";

export interface GroupByOption {
  key: RequestAggregateGroupBy;
  label: string;
}

const GROUP_BY_OPTIONS: GroupByOption[] = [
  { key: "client", label: "Client" },
  { key: "lob", label: "LOB" },
  { key: "engagementType", label: "Engagement type" },
  { key: "requestType", label: "Request type" },
  { key: "country", label: "Country" },
  { key: "assignedTo", label: "Owner" },
  { key: "team", label: "Team" },
  { key: "manager", label: "Manager" },
  { key: "division", label: "Division" },
  { key: "calculatedStatus", label: "Status" },
];

interface Preset {
  label: string;
  keys: RequestAggregateGroupBy[];
}

const PRESETS: Preset[] = [
  { label: "By client", keys: ["client"] },
  { label: "By LOB", keys: ["lob"] },
  { label: "By engagement", keys: ["engagementType"] },
  { label: "By request type", keys: ["requestType"] },
  { label: "By team", keys: ["team"] },
  { label: "Client × LOB", keys: ["client", "lob"] },
  { label: "Client × Engagement", keys: ["client", "engagementType"] },
];

interface Props {
  selected: RequestAggregateGroupBy[];
  onChange: (next: RequestAggregateGroupBy[]) => void;
}

export function RequestGroupByChips({ selected, onChange }: Props) {
  const toggle = (key: RequestAggregateGroupBy) => {
    if (selected.includes(key)) {
      if (selected.length > 1) onChange(selected.filter((k) => k !== key));
      return;
    }
    onChange([...selected, key]);
  };

  return (
    <div className="groupby">
      <span className="lbl">Group by</span>
      {GROUP_BY_OPTIONS.map((opt) => {
        const active = selected.includes(opt.key);
        return (
          <span
            key={opt.key}
            className={"groupby-chip " + (active ? "active" : "")}
            onClick={() => toggle(opt.key)}
          >
            {opt.label}
            {active && (
              <span className="material-symbols-rounded" style={{ fontSize: 12 }}>
                close
              </span>
            )}
          </span>
        );
      })}
      <div className="groupby-presets">
        {PRESETS.map((p) => (
          <span key={p.label} className="preset" onClick={() => onChange(p.keys)}>
            {p.label}
          </span>
        ))}
      </div>
    </div>
  );
}

export const REQUEST_GROUP_LABEL_BY_KEY: Record<RequestAggregateGroupBy, string> = Object.fromEntries(
  GROUP_BY_OPTIONS.map((o) => [o.key, o.label]),
) as Record<RequestAggregateGroupBy, string>;
